import { type FC } from 'react';
import { Button, Paper, Stack, Text } from '@mantine/core';
import { IconLock, IconLockOpen } from '@tabler/icons-react';
import { PayoutTraderStatus } from '~/entities/payout';

interface TraderActionsCardProps {
    isBlockPending: boolean;
    isUnBlockPending: boolean;
    onBlock: () => void;
    onUnBlock: () => void;
    status?: PayoutTraderStatus;
    traderId?: string;
}

export const TraderActionsCard: FC<TraderActionsCardProps> = ({
    isBlockPending,
    isUnBlockPending,
    onBlock,
    onUnBlock,
    status,
    traderId,
}) => {
    if (!traderId || status === PayoutTraderStatus.STATUS_CREATED) {
        return null;
    }

    return (
        <Paper
            p='md'
            radius='md'
            withBorder
        >
            <Stack gap='sm'>
                <Text
                    fw={600}
                    size='sm'
                >
                    Действия
                </Text>

                {status === PayoutTraderStatus.STATUS_ACTIVE && (
                    <Button
                        color='red'
                        variant='light'
                        leftSection={<IconLock size={16} />}
                        onClick={onBlock}
                        disabled={isBlockPending}
                        loading={isBlockPending}
                    >
                        Заблокировать
                    </Button>
                )}

                {status === PayoutTraderStatus.STATUS_BLOCKED && (
                    <Button
                        variant='light'
                        leftSection={<IconLockOpen size={16} />}
                        onClick={onUnBlock}
                        disabled={isUnBlockPending}
                        loading={isUnBlockPending}
                    >
                        Разблокировать
                    </Button>
                )}
            </Stack>
        </Paper>
    );
};
